var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticClass:"ship-card-btn"},[_c('booking-calendar-filter')],1),_c('el-card',{staticClass:"book-calendar-main-kan-style"},[_c('el-row',[_c('booking-calendar-base')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }